export default class PdvData {
  constructor({
    modelo = 65,
    tpNF = 1,
    serie = null,
    remainder = 0,
    discount = 0,
    discountIsPercentage = false,
    extraValue = 0,
    freightPrice = 0,
    price = 0,
    observation = '',
    buyer = {},
    seller = {},
    paymentModeCollection = [],
    productOfTradeCollection = [],
    tipoIntermediador = {
      id: 0,
      name: 'Operação sem intermediador (em site ou plataforma própria)',
    },
    intermediador = null,
    usuarioIntermediador = null,
    homeDelivery = false,
  }) {
    this.modelo = modelo;
    this.tpNF = tpNF;
    this.serie = serie;
    this.remainder = remainder;
    this.discount = discount;
    this.discountIsPercentage = discountIsPercentage;
    this.extraValue = extraValue;
    this.freightPrice = freightPrice;
    this.price = price;
    this.observation = observation;
    this.buyer = buyer;
    this.seller = seller;
    this.paymentModeCollection = paymentModeCollection;
    this.productOfTradeCollection = productOfTradeCollection;
    this.tipoIntermediador = tipoIntermediador;
    this.intermediador = intermediador;
    this.usuarioIntermediador = usuarioIntermediador;
    this.homeDelivery = homeDelivery;
  }
}
